import { z } from 'zod';

import { MethodNodeSchema } from './nodes.js';

const ContextTermValueSchema = z.union([
  z.string(),
  z.strictObject({ '@id': z.string(), '@type': z.literal('@id').optional() }),
]);

export const JsonLdContextSchema = z.record(z.string(), ContextTermValueSchema);

/**
 * A whole method as JSON-LD: one context plus a flat node set. Flat and not
 * nested because `MethodVersion` is a single aggregate (00-ARCHITECTURE §3) and
 * every interesting invariant is graph-wide.
 */
export const MethodGraphSchema = z.strictObject({
  '@context': JsonLdContextSchema,
  '@graph': z.array(MethodNodeSchema),
});

export type MethodGraph = z.infer<typeof MethodGraphSchema>;
